var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 0H1.11111C0.816426 0 0.533811 0.120408 0.325437 0.334735C0.117063 0.549062 0 0.839753 0 1.14286V14.0952C0.00243375 14.5996 0.19832 15.0827 0.545084 15.4393C0.891847 15.796 1.36146 15.9975 1.85185 16H18.1481C18.6385 15.9975 19.1082 15.796 19.4549 15.4393C19.8017 15.0827 19.9976 14.5996 20 14.0952V1.14286C20 0.839753 19.8829 0.549062 19.6746 0.334735C19.4662 0.120408 19.1836 0 18.8889 0ZM16.037 2.28571L10 7.97143L3.96296 2.28571H16.037ZM2.22222 13.7143V3.74286L9.25 10.3619C9.45383 10.5567 9.72176 10.665 10 10.665C10.2782 10.665 10.5462 10.5567 10.75 10.3619L17.7778 3.74286V13.7143H2.22222Z",
    fill: "#6F9FE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f2e2bcfd.svg";
export { ForwardRef as ReactComponent };